const Colors = {
    Elmt: {
        Black: 0x303035,
        White: 0xFFFFFF,
        LightGrey: 0xF3F3F4,
        Grey: 0xE5E5E8,
        DarkerGrey: 0xBEB8B8,
        DarkGrey: 0x6C6E76,
        GreyBlue: 0x9799A3,
        Blue: 0x5558E5,
        DarkBlue: 0x1D2D43,
        Orange: 0xE18628,
        Red: 0xCC5050,
        Rose: 0xF7A0A0,
        GreenJardin: 0xE5F6A4,
        Green: 0x7AB97E
    },
    Text: {
        Black: "#303035",
        White: "#FFFFFF",
        LightGrey: "#F3F3F4",
        Grey: "#E5E5E8",
        DarkerGrey: "#BEB8B8",
        DarkGrey: "#6C6E76",
        GreyBlue: "#9799A3",
        Blue: "#5558E5",
        DarkBlue: "#1D2D43",
        Orange: "#E18628",
        Red: "#CC5050",
        Rose: "#F7A0A0",
        GreenJardin: "#E5F6A4",
        Green: "#7AB97E"
    }
}

export {
    Colors
}